import { ICommand, IQuery } from 'core-ts-types';
import { ISection, ICourse } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionSwapModel } from '../../models/course_section_swap_model';
import { SectionSwapServant } from '../../servants/section_swap_servant';
import { ClearSwapSelectionsCommand } from '../../commands/clear_swap_selections_command';
import { ClearTransientAccessCredCommand } from '../../../prevent_transient_access/commands/clear_transient_access_cred_command';
import { LoadSectionRegistrationAttributesCommand } from '../../../registration_attributes/commands/load_section_registration_attributes_command';
import { SchedulerNotificationServant } from '../../../views/course_scheduler/servants/scheduler_notification_servant';
import { GetTermPinCommand } from '../../../components/term_pin/commands/get_term_pin_command';

export class SwapHeaderController {
  private classTitle: string;
  private swapModeLabel: string;
  private headerLabel: string;
  private iconTheme: string = 'white';
  private section: ISection;
  private hasMultiSection: boolean;
  private inSwapSectionList: boolean;
  private showBackButton: boolean;
  private showSwapDialog: boolean = false;
  constructor(
    private ngSectionSwapPreviewSwapQuery: IQuery,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngSectionSwapServant: SectionSwapServant,
    private clearSwapSelectionsCommand: ClearSwapSelectionsCommand,
    private getTermPinCommand: GetTermPinCommand,
    private $q: ng.IQService,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand,
    private loadSectionRegistrationAttributesCommand: LoadSectionRegistrationAttributesCommand,
    private ngSchedulerNotificationServant: SchedulerNotificationServant
  ) {}

  $onInit() {
    this.init();
  }

  init() {
    this.section = _4.find(this.ngSectionSwapPreviewSwapQuery.result.from, {
      section_type: this.ngCourseSectionSwapModel.read().from_section.section_type
    });
    this.hasMultiSection = this.section && !_4.isEmpty(this.section._section_type);
    this.classTitle = this.section ? this.getHeaderTitle(this.section._course) : ``;
    this.showBackButton = this.ngSectionSwapServant.showSwapBackButton(this.$stateParams.swapCourse);
    if (this.$stateParams.swapCourse === 'true') {
      this.swapModeLabel = 'Courses';
      this.headerLabel = 'Pick a new course to swap ';
    } else {
      this.swapModeLabel = 'Times';
      this.headerLabel = 'Pick a new time for ';
    }
  }

  getHeaderTitle(course: ICourse) {
    return course ? `${course.nk} ${course.title}` : ``;
  }

  private __onExitTriggerEnded() {
    this.exitSwap();
  }

  exitSwap() {
    this.clearSwapSelectionsCommand().then(() => this.$state.go('my.schedule.registration'));
  }

  changeIconThemeToWhite() {
    this.iconTheme = 'white';
  }

  changeIconThemeToGray() {
    this.iconTheme = 'gray';
  }

  private __onSwapTriggerEnded() {
    this.openSwapConfirmationDialog();
  }

  openSwapConfirmationDialog() {
    if (this.ngSectionSwapPreviewSwapQuery.result.disableSwap) {
      this.ngSchedulerNotificationServant.showErrorNotification('That section is not valid to swap');
      return;
    }
    const regAttributesForSections: Array<angular.IPromise<IQuery[]>> = [];
    this.ngSectionSwapPreviewSwapQuery.result.to.forEach((section) =>
      regAttributesForSections.push(this.loadSectionRegistrationAttributesCommand(section.id))
    );

    this.$q
      .all(regAttributesForSections.concat([this.clearTransientAccessCredCommand()]))
      .then(() => this.getTermPinCommand(this.$stateParams.termId))
      .then(() => {
        this.showSwapDialog = true;
      });
  }
}

angular.module('capability-ng-scheduler').component('swapHeader', {
  templateUrl: 'capability-ng-scheduler/src/swap/components/swap_header/swap_header.html',
  controller: SwapHeaderController,
  bindings: {}
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/swap_header/swap_header.ts